import { render, staticRenderFns } from "./scene_info.vue?vue&type=template&id=4891e157&scoped=true&"
import script from "./scene_info.vue?vue&type=script&lang=js&"
export * from "./scene_info.vue?vue&type=script&lang=js&"
import style0 from "./scene_info.vue?vue&type=style&index=0&id=4891e157&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4891e157",
  null
  
)

export default component.exports